package com.tedd.db

import kotlin.Long

public data class CountByParent(
  public val total: Long,
  public val done: Long?,
)
